/* Ralhum sports tabs. WAI-ARIA tabs pattern: https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
   Without this script every panel shows stacked, with its own heading. */
(function () {
  function init(root) {
    if (!root || root.classList.contains('is-enhanced')) return;
    var list = root.querySelector('[data-rs-tablist]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    if (!list || !tabs.length) return;
    root.classList.add('is-enhanced');

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        t.classList.toggle('is-active', on);
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = tabs.length, next = null;
        if (k === 'ArrowRight') next = (i + 1) % n;
        else if (k === 'ArrowLeft') next = (i - 1 + n) % n;
        else if (k === 'Home') next = 0;
        else if (k === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); select(next, true); }
      });
    });
    select(0, false);
  }
  function initAll() { document.querySelectorAll('[data-rs-tabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rs-tabs]')); });
})();
